import { lazy } from 'react';

export const NotificationsPage = lazy(() => import('./NotificationsPage'));
